import { fetchPublicRelease, reloadApp } from '@/composables/useAppUpdate'
import { runningAppRelease } from '@/utils/running-app-release'

const RECOVERY_KEY = 'tb-ticket-admin-failed-import-recovery'

/** Recover once per release transition when a deployment invalidates a lazy import. */
export function registerFailedImportRecovery(): void {
  let checking = false

  window.addEventListener('vite:preloadError', () => {
    if (checking) return
    checking = true

    void (async () => {
      try {
        const remote = await fetchPublicRelease()
        if (!remote) return
        const changed = remote.version !== runningAppRelease.version
          || Boolean(remote.buildId && remote.buildId !== runningAppRelease.buildId)
        if (!changed) return

        const transition = JSON.stringify({ from: runningAppRelease, to: remote })
        if (sessionStorage.getItem(RECOVERY_KEY) === transition) return
        sessionStorage.setItem(RECOVERY_KEY, transition)
        await reloadApp()
      } catch (error) {
        console.warn('[AppUpdate] Failed to recover a lazy import:', error)
      } finally {
        checking = false
      }
    })()
  })
}
